// Faixa de aviso do modo manutenção (somente leitura). Aparece para todos enquanto
// app_maintenance.enabled = true; muda o texto para quem tem permissão de editar.
import { useEffect, useState } from 'react';
import { useAuth } from '../lib/auth';
import { loadMaintenance, type MaintenanceState } from '../lib/maintenance';

const DEFAULT_MSG =
  'Painel em manutenção (migração em andamento). Neste momento ele está em modo SOMENTE LEITURA: você pode consultar, mas não alterar.';

export function MaintenanceBanner() {
  const { userId } = useAuth();
  const [state, setState] = useState<MaintenanceState | null>(null);

  useEffect(() => {
    let alive = true;
    const run = () => loadMaintenance().then((s) => alive && setState(s));
    run();
    const timer = setInterval(run, 120000); // confere a cada 2 minutos
    return () => {
      alive = false;
      clearInterval(timer);
    };
  }, []);

  if (!state?.enabled) return null;
  const canEdit = userId ? state.allowUserIds.includes(userId) : false;

  return (
    <div className="maint-banner" role="status">
      <span aria-hidden="true">🔧</span>{' '}
      {canEdit
        ? 'Modo manutenção ativo: o painel está SOMENTE LEITURA para a equipe. Só você e o Guilherme podem editar.'
        : state.message || DEFAULT_MSG}
    </div>
  );
}
